<app-add-form
  data-testid="virtual-warehouse-create-add-form"
  #addForm
  [title]="formConfig().title"
  [formFields]="formConfig().formFields"
  [headerActions]="formConfig().headerActions"
  [tableSections]="formConfig().tableSections"
  [initialData]="initialData()"
  [loading]="loading()"
  (formAction)="onFormAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
></app-add-form>

<p-toast data-testid="virtual-warehouse-create-toast" position="top-right"></p-toast>
